import React from 'react';
/**
 * TabContext
 * {
 *  activeTabId: PropTypes.any
 * }
 */

export var TabContext = React.createContext({});